import React, { useState } from "react";
import moment from "moment-timezone";

import AppBox from "@/components/AppBox";
import AppText from "@/components/AppText";
import AppTableContainer from "@/components/AppTableContainer";
import AppIcon from "@/components/AppIcon"; // Assuming this replaces MUI icons
import AppPagination from "@/components/Tables/AppPagination"; // Assuming a reusable pagination component

// Interface for table rows
interface AlertRow {
  type: "error" | "warning" | "info";
  created_at: string;
  title: string;
  message: string;
}

interface AdminAlertsTableProps {
  tableRows: AlertRow[];
}

// Type-specific color and icons
const alertStyles = {
  error: {
    icon: <AppIcon name="danger" className="text-error" />,
    bg: "bg-red-100",
    text: "text-red-600",
  },
  warning: {
    icon: <AppIcon name="warning" className="text-orange-500" />,
    bg: "bg-orange-100",
    text: "text-orange-600",
  },
  info: {
    icon: <AppIcon name="info" className="text-blue-500" />,
    bg: "bg-blue-100",
    text: "text-blue-600",
  },
};

const AdminAlertsTable: React.FC<AdminAlertsTableProps> = ({ tableRows }) => {
  const tz = moment.tz.guess();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const slicedData = tableRows.slice(startIndex, endIndex);

  const handleChangePage = (newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  return (
    <AppBox fullWidth column gap={4} justify="between" className="overflow-auto">
      <AppTableContainer>
        <table className="table-auto w-full text-sm bg-white">
          <thead className="sticky top-0">
            <tr className="bg-gray-200 text-left uppercase">
              <th className="p-3">Type</th>
              <th className="p-3">Date</th>
              <th className="p-3">Title</th>
              <th className="p-3">Message</th>
            </tr>
          </thead>
          {/* <thead className="bg-gray-200 text-gray-700 uppercase text-sm sticky top-0">
            <tr>
              <th className="p-3">Type</th>
              <th className="p-3">Date</th>
              <th className="p-3">Title</th>
              <th className="p-3">Message</th>
            </tr>
          </thead> */}

          <tbody>
            {slicedData.length ? (
              slicedData.map((row, index) => {
                const { icon, bg, text } = alertStyles[row.type];
                return (
                  <tr key={index} className={`border-b ${bg} hover:bg-gray-50`}>
                    {/* Type */}
                    <td className="p-3 py-6">
                      <AppBox align="center" gap={2}>
                        {icon}
                        <AppText className={`uppercase ${text}`}>{row.type}</AppText>
                      </AppBox>
                    </td>

                    {/* Date */}
                    <td className="p-3">
                      {moment(row.created_at).tz(tz).format("D MMM HH:mm:ss")}
                    </td>

                    {/* Title */}
                    <td className="p-3">{row.title}</td>

                    {/* Message */}
                    <td className="p-3">
                      <div dangerouslySetInnerHTML={{ __html: row.message }} />
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={4} className="p-4 text-center">
                  No results
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </AppTableContainer>

      {/* Pagination */}
      {/* {tableRows.length > 0 && (
        <AppBox justify="end" className="mt-4">
          <AppPagination
            totalRows={tableRows.length}
            rowsPerPage={rowsPerPage}
            currentPage={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={(newRows) => handleChangeRowsPerPage({ target: { value: newRows.toString() } } as any)}
          />
        </AppBox>
      )} */}
    </AppBox>
  );
};

export default AdminAlertsTable;